module.exports = __webpack_public_path__ + "media/site/images/technologies/js-icon-f885e25027d2db95f0533213f411ab23.svg";